import { Action } from 'typescript-fsa';
import * as dotProp from 'dot-prop-immutable';

import { createReducer, getArrayAfterAsyncCall } from '@topconagriculture/frontend-utils';

import { Zone } from './zones.types';
import { createZone, deleteZone, getZonesList, updateZone } from './zones.actions';

export type ZonesState = Zone[];

export const ZonesInitialState: ZonesState = [];

const ZonesReducer = createReducer(ZonesInitialState, {
  [getZonesList.done.type]: (state: ZonesState, action: ReturnType<typeof getZonesList.done>) =>
    getArrayAfterAsyncCall<Zone>(state, action),
  [createZone.done.type]: (state: ZonesState, action: Action<{ result: Zone }>) => [...state, action.payload.result],
  [updateZone.done.type]: (state: ZonesState, action: Action<{ result: Zone }>) => {
    const updatedZone = action.payload.result;
    return state.map((zone) => (zone.id === updatedZone.id ? updatedZone : zone));
  },
  [deleteZone.done.type]: (state: ZonesState, action: ReturnType<typeof deleteZone.done>) => {
    const deletedZoneId = action.payload.params.id;
    const indexFound = state.findIndex((zone: Zone) => zone.id === deletedZoneId);
    return dotProp.delete(state, indexFound);
  },
});

export default ZonesReducer;
